import React, { useMemo } from 'react';

import useApi from '@/hooks/useApi';

import { TCard } from '@/services/requests/Recommendation/types/template7';

import { clearHtmlTags } from '@/helpers/HtmlHelper/clearHtmlTags';
import { getValue } from '@/helpers/GetValueHelper';

import { handleCardInteraction } from './handleCardInteraction';

export interface ICardProps {
  data: TCard;
  cards: TCard[];
  containerRef: React.RefObject<HTMLDivElement>;
  recommendationId: string;
}

export const Card = React.memo(
  ({ data, cards, containerRef, recommendationId }: ICardProps) => {
    const { id, title, label, description, notes, cta, Tag } = data;

    const { Api } = useApi();

    const cardLabel = clearHtmlTags(label.text);

    const cardTitle = clearHtmlTags(title.text);

    const cardDescription = clearHtmlTags(description.text);
    const imageUrl = getValue(data, 'image.image');

    const tags = useMemo(() => {
      if (Array.isArray(Tag)) {
        return Tag;
      }
      return [];
    }, [Tag]);

    return (
      <a
        href={cta.link}
        data-link={cta.link}
        title={clearHtmlTags(title.text)}
        className="vitrine-template7__cards__card"
        key={id}
        data-id={id}
        data-testid={id}
        target="_blank"
        rel="noreferrer"
        onClick={e =>
          handleCardInteraction({
            event: e,
            cardId: id,
            Api,
            id: recommendationId,
            tabName: 'tabName',
            cards,
            containerRef,
          })
        }
      >
        <figure className="vitrine-template7__cards__card--image">
          <img loading="lazy" src={imageUrl} alt={clearHtmlTags(title.text)} />
        </figure>
        <div className="vitrine-template7__cards__card--text">
          <section>
            <img
              src={cardLabel}
              alt={clearHtmlTags(title.text)}
              className="vitrine-template7__cards__card--text-club"
            />

            <strong className="vitrine-template7__cards__card--text-title">
              {cardTitle}
            </strong>
            <p className="vitrine-template7__cards__card--text-description">
              {cardDescription}
            </p>
            <div className="vitrine-template7__cards__card--text-benefits">
              <section>
                {tags.map(tag => (
                  <span key={clearHtmlTags(tag.tag_text)}>
                    {clearHtmlTags(tag.tag_text)}
                  </span>
                ))}
              </section>
            </div>
          </section>
          <p className="vitrine-template7__cards__card--text-date">{notes}</p>
        </div>
      </a>
    );
  },
);
